import AdbSelect from './src/adb-select.vue';

AdbSelect.install = function (Vue) {
  Vue.component(AdbSelect.name, AdbSelect);
};

export default AdbSelect;
